var exports = {
  "Pc": "StickerFormFields.module__tagsContainer___TG1KcH",
  "Pr": "StickerFormFields.module__tagsHeader___TG1KcH",
  "cm": "StickerFormFields.module__tagsLabel___TG1KcH",
  "jw": "StickerFormFields.module__tagInputRow___TG1KcH",
  "Cs": "StickerFormFields.module__tagsList___TG1KcH",
  "Tc": "StickerFormFields.module__tag___TG1KcH",
  "xH": "StickerFormFields.module__tagRemoveButton___TG1KcH",
};

module.exports = exports;
